import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import SportsLoader from '../../../../../components/sportsLoader';
import MatchCheerCommentItem from '../commentItem';
import { InView } from 'react-intersection-observer';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import ImageView from '../imageView';
import styled, { css } from 'styled-components';
import useUsersStore from '../../../../../hooks/useUsersStore';
import { useLocation } from 'react-router-dom';
import { FormatUtil } from '../../../../../common/utils/formatUtil';

const MatchCheerCommentList = ({
  comments,
  loading,
  teams,
  getCheerMore,
  setRef,
  isSmallView,
  isInit,
  setViewUserAction,
  setSelectedUser,
  blackList,
  cheerCount,
  viewSuperChatCarousel,
  viewChat
}) => {
  const location = useLocation();
  const usersStore = useUsersStore();

  const scrollRef = useRef();
  const listRef = useRef();
  const [initView, setInitView] = useState(false);
  const [init, setInit] = useState(false);
  const [defaultList, setList] = useState([]);
  const [viewImage, setViewImage] = useState('');
  const [viewScrollButton, setScrollButton] = useState(false);
  const [animateChatId, setAnimateChatId] = useState(null);

  const scrollRefScrollEvent = (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop >=
      event.target.clientHeight + 30
    ) {
      setScrollButton(true);
    } else {
      setScrollButton(false);
    }
  };

  const onClickScrollButton = () => {
    scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  };

  useLayoutEffect(() => {
    if (!!scrollRef.current) {
      scrollRef.current.addEventListener('scroll', scrollRefScrollEvent);
      setRef(scrollRef.current);
      disableBodyScroll(scrollRef.current);
    }
  }, [scrollRef.current]);
  useLayoutEffect(() => {
    if (!!listRef.current && isInit) {
      setTimeout(
        () => (scrollRef.current.scrollTop = listRef.current.scrollHeight),
        10
      );
    }
  }, [listRef.current, isInit]);

  useEffect(() => {
    return () => {
      enableBodyScroll(scrollRef.current);
      scrollRef.current.removeEventListener('scroll', scrollRefScrollEvent);
    };
  }, []);

  useEffect(() => {
    if (listRef.current) {
      scrollRef.current.scrollTop = listRef.current.clientHeight;
    }
  }, [isSmallView]);

  useEffect(() => {
    if (!loading) {
      setInitView(true);
      setList(
        comments.filter((comment) => {
          return !blackList.includes(comment.user_id);
        })
      );
    } else {
      setInitView(false);
    }
  }, [loading, comments]);

  const renderViewCheck = useMemo(() => {
    return initView && defaultList.length > 0;
  }, [comments, initView, defaultList]);

  const basePathname = useMemo(() => {
    const locationPathArray = location.pathname.split('/');
    return `/${locationPathArray[1]}/${locationPathArray[2]}/${locationPathArray[3]}`;
  }, [location]);

  const setEmpty = () => {
    if (loading && initView) {
      return <SportsLoader />;
    } else {
      return (
        <div className="empty_cheer">
          <div className="inner">
            <p>등록된 응원글이 없습니다.</p>
            <p>첫번째 응원글을 남겨주세요.</p>
          </div>
        </div>
      );
    }
  };

  const onClickParent = (parentId) => {
    if (!!document.getElementById(parentId)) {
      scrollRef.current.scrollTop =
        document.getElementById(parentId).offsetTop - 70;
      setAnimateChatId(parentId);
      setTimeout(() => setAnimateChatId(null), 1500);
    }
  };

  return (
    <div
      className="cheer_list"
      style={{
        height: viewSuperChatCarousel
          ? 'calc(100% - 114px)'
          : 'calc(100% - 48px)',
        paddingTop: viewChat ? '66px' : '0'
      }}
    >
      {cheerCount > 0 && (
        <CheersCount>{FormatUtil.numberUnitConvert(cheerCount)}</CheersCount>
      )}
      <div className="inner" ref={scrollRef}>
        {initView ? (
          renderViewCheck ? (
            <ul ref={listRef}>
              <InView
                as="li"
                onChange={(inView, entry) => {
                  if (inView) {
                    if (init) {
                      getCheerMore(scrollRef.current.scrollHeight);
                    } else {
                      setInit(true);
                    }
                  }
                }}
              >
                <div style={{ height: 5, width: '100%' }} />
              </InView>
              {defaultList.map((item, idx) => {
                return (
                  <MatchCheerCommentItem
                    key={idx}
                    idx={idx}
                    item={item}
                    teams={teams}
                    setViewImage={setViewImage}
                    setSelectedUser={setSelectedUser}
                    setViewUserAction={setViewUserAction}
                    loginUserId={usersStore.data.mb_id}
                    basePathname={basePathname}
                    onClickParent={onClickParent}
                    animate={animateChatId === item.id}
                  />
                );
              })}
            </ul>
          ) : (
            setEmpty()
          )
        ) : (
          <SportsLoader />
        )}
      </div>
      <ImageView viewImage={viewImage} onClose={() => setViewImage('')} />
      <ScrollBottom view={viewScrollButton} onClick={onClickScrollButton} />
    </div>
  );
};

const ScrollBottom = ({ view, onClick }) => {
  return <ScrollBottomButton view={view} onClick={onClick} />;
};

const ScrollBottomButton = styled.button`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #333;
  z-index: 10;
  position: absolute;
  bottom: 20px;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  :before {
    content: '';
    background: url('/images/ic-scroll-bottom.svg') no-repeat center center;
    width: 100%;
    height: 100%;
    background-size: 14px;
  }

  @keyframes moveUp {
    0% {
      transform: translate(-50%, 30%);
      opacity: 0;
    }
    100% {
      transform: translate(-50%, 0);
      opacity: 1;
    }
  }

  ${(props) =>
    props.view
      ? css`
          animation-duration: 0.5s;
          animation-name: moveUp;
          animation-direction: normal;
          animation-fill-mode: forwards;
        `
      : css`
          display: none;
        `}
`;

const CheersCount = styled.div`
  background-color: rgba(0, 0, 0, 0.36);
  height: 22px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  position: absolute;
  right: 15px;
  top: 10px;
  z-index: 11;
  color: #fff;
  border-radius: 11px;
  font-size: 10px;
  :before {
    content: '';
    display: block;
    background: url('/images/ic-cheers-w.svg') no-repeat center center;
    background-size: 9px;
    width: 9px;
    height: 9px;
    margin-right: 5px;
  }
`;

export default MatchCheerCommentList;
